<template>
  <button
    type="button"
    class="publisher-chat-avatar"
    :disabled="!available || busy || isSelf"
    :aria-label="$t('pcHome.contactPublisher', { name: displayName })"
    :title="displayName"
    @click.stop="$emit('chat')"
    @keydown.stop
    @keyup.stop
  >
    <img
      v-if="avatar && !imageFailed"
      :src="avatar"
      alt=""
      loading="lazy"
      @error="imageFailed = true"
    />
    <span v-else aria-hidden="true">{{ initial }}</span>
    <span v-if="busy" class="avatar-busy" aria-hidden="true">…</span>
  </button>
</template>
<script>
import { resolveAgentServiceCurrentUserId } from "@/services/agent-service-state";
/** 首页发布人专用触控入口，阻止卡片跳转；用户身份不由供应商ID推断。 */
export default {
  name: "PublisherChatAvatar",
  props: {
    name: String,
    avatar: String,
    userId: [String, Number],
    available: Boolean,
    busy: Boolean,
  },
  data: () => ({ imageFailed: false }),
  computed: {
    displayName() {
      return this.name || this.$t("pcHome.publisher");
    },
    initial() {
      return Array.from(String(this.name || "").trim())[0] || "?";
    },
    isSelf() {
      return (
        Boolean(this.userId) &&
        String(this.userId) ===
          String(resolveAgentServiceCurrentUserId(this.$store.state.user || {}))
      );
    },
  },
  watch: {
    avatar() {
      this.imageFailed = false;
    },
  },
};
</script>
<style lang="less" scoped>
.publisher-chat-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  padding: 4px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #246de0;
  cursor: pointer;
  > img,
  > span:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #eef4ff;
    object-fit: cover;
    font-size: 16px;
    font-weight: 600;
  }
  .avatar-busy {
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 8px;
    padding: 0 4px;
    background: #fff;
  }
  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid #4286f5;
    outline-offset: -2px;
  }
}
</style>
